// refs:
// https://github.com/tinymce/tinymce/issues/3592
// https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component

// https://icons.getbootstrap.com/
import * as _ww_tools from "./wwtools.js";


import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './index.css';

import {
  createBrowserRouter,
  RouterProvider,
  useParams,
  Outlet
} from "react-router-dom";

import App from './App.jsx';
import App2 from './App2';
import App3 from "./app3/App3.jsx";
import App3Pdts from "./app3/pages/Pdts.jsx";
import App3Poses from "./app3/pages/Poses.jsx";


import reportWebVitals from './reportWebVitals';
import React from "react";

import BBS from "./BBS/BBS"
import PdtCatDetail from './components/PdtCatDetail/PdtCatDetail.jsx';
import PdtDetail from './components/PdtDetail/PdtDetail.jsx';
import Tbl from './input_types/Tbl/Tbl.jsx';
import InventoryChk from './manage2/InventoryChk/InventoryChk.jsx';
import InventoryChk2 from './manage2/InventoryChk/InventoryChk2.jsx';
import ProductChk from './manage2/ProductChk/ProductChk.jsx';
import InventoryVerify from "./manage2/InventoryVerify/InventoryVerify.jsx";

import InventoryHistory from './manage2/InventoryHistory/InventoryHistory.jsx';
import CombinePdts from './manage2/CombinePdts/CombinePdts.jsx';
import TableDesign from './manage2/TableDesign/TableDesign.jsx';
import UsersSettings from "./manage2/UsersSettings/UsersSettings.jsx";
import MenuSettings from "./manage2/MenuSettings/MenuSettings.jsx";

import SalesOrderProcess from './manage2/SalesOrderProcess/SalesOrderProcess.jsx';

import ErrorPage from "./error-page.jsx";
import Root from "./routes/root";
import Detail from "./routes/detail.jsx";
import Intro from './app2/Intro/Intro.jsx';
import AboutUs from "./app2/AboutUs/AboutUs.jsx";

import Manage2 from './Manage2.jsx';

// import Login, {useLogin} from './Login/Login.jsx';
import SearchResult from "./components/SearchResult/SearchResult.jsx";


import { useState } from 'react';
import Cookies from "js-cookie";
import { getTokenName, siteMode, getBkendUrl, getRootUrl, setBkendUrl, setRootUrl } from './consts.js';
import axios_with_token, { TblLogs, UrlsSettings } from './axios_with_token.js';
import SiteEditor from './app2/SiteEditor/SiteEditor.jsx';

import { DataProvider, ErrorBoundary, useData } from "./consts.js";

import InventoryQuery from "./manage2/InventoryQuery/InventoryQuery.jsx";

import OrderSystem from "./orderSystem/OrderSystem.jsx";
import OSHome from "./orderSystem/pages/Home.jsx";
import ProductDetail from "./orderSystem/pages/ProductDetail.jsx";
import Checkout from "./orderSystem/pages/Checkout.jsx";
import Cart from "./orderSystem/pages/Cart.jsx";

import WWAppHome from "./wwapp/pages/Home.jsx";
import WWAppAbout from "./wwapp/pages/About.jsx";
import WWAppCategory from "./wwapp/pages/Product.jsx";
import WWAppProductDetails from "./wwapp/pages/ProductDetails.jsx";
import WWAppCart from "./wwapp/pages/Cart.jsx";
import WWAppCheckout from "./wwapp/pages/Checkout.jsx";
import WWAppContact from "./wwapp/pages/Contact.jsx";
import WWAppAccount from "./wwapp/pages/Account.jsx";
import WWAppRegister from "./wwapp/pages/Register.jsx";
import WWAppSignIn from "./wwapp/pages/SignIn.jsx";
import WWAppSubsidaries from "./wwapp/pages/Subsidaries.jsx";

import WWAppManageProducts from "./wwapp/pages/manage/Products.jsx";
import WWAppManageAccounts from "./wwapp/pages/manage/Accounts.jsx";
import WWAppManageOrders from "./wwapp/pages/manage/Orders.jsx";

import WWAdminDashboard from "./wwAdmin/pages/dashboard.jsx";
import WWAdminInventoryQuery from "./wwAdmin/pages/inventoryQuery.jsx";

const rootUrl = getRootUrl();
const bkendUrl = getBkendUrl();

const Inventory = props=>{
  return <>
    <Outlet />
  </>
};

function QueryPdt(props){
  const [token, setToken] = useState(Cookies.get(getTokenName()));

  // if(!token) {
  //   return <Login setToken={setToken}/>
  // }
  
  return <CombinePdts 
    hide={true}
    summaryFlds={"pdtSnBrandAbbr,chkQtyPCNow|quantity (PC),chkQtyDZNow|quantity (DZ)"}
  />
}


// place holders for compatibility
window.arrs = {};
window._ww_tools = _ww_tools;
window.mergeDeeps = _ww_tools.mergeDeeps;

const Test = ({})=>{
  return <div>
    <h1>manage test</h1>
  </div>;
}

const routerDefTest = [
  {
    path: `${rootUrl}/`,
    element: <div>app test</div>,
    errorElement: <ErrorPage />
  },
  {
    path: `${rootUrl}/app2/manage/`,
    element: <App />,
    errorElement: <ErrorPage />
  },

]

const routerDef = [
  {
    path: `${rootUrl}/`,
    element: <App />,
    errorElement: <ErrorPage />
  },

  // {
  //   path: `${rootUrl}/login`,
  //   element: <Login />,
  //   errorElement: <ErrorPage />
  // },

  // {
  //   path: `${rootUrl}/queryPdt`,
  //   element: <QueryPdt />,
  //   errorElement: <ErrorPage />
  // },
  {
    path: `${rootUrl}/wwapp/`,
    errorElement: <ErrorPage />,
    // element: <WWAppHome></WWAppHome>
    element: <WWAppCategory></WWAppCategory>,
  },
  {
    path: `${rootUrl}/wwapp/about`,
    element: <WWAppAbout></WWAppAbout>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/category`,
    element: <WWAppCategory></WWAppCategory>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/productdetails/:id`,
    element: <WWAppProductDetails></WWAppProductDetails>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/cart`,
    element: <WWAppCart></WWAppCart>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/checkout`,
    element: <WWAppCheckout></WWAppCheckout>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/contact`,
    element: <WWAppContact></WWAppContact>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/account`,
    element: <WWAppAccount></WWAppAccount>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/register`,
    element: <WWAppRegister></WWAppRegister>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/signin`,
    element: <WWAppSignIn></WWAppSignIn>,
    errorElement: <ErrorPage />,
  },

   {
    path: `${rootUrl}/wwapp/subsidaries`,
    element: <WWAppSubsidaries></WWAppSubsidaries>,
    errorElement: <ErrorPage />,
  },
 
  {
    path: `${rootUrl}/wwapp/manage/products`,
    element: <WWAppManageProducts></WWAppManageProducts>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/manage/accounts`,
    element: <WWAppManageAccounts></WWAppManageAccounts>,
    errorElement: <ErrorPage />,
  },
  {
    path: `${rootUrl}/wwapp/manage/orders`,
    element: <WWAppManageOrders></WWAppManageOrders>,
    errorElement: <ErrorPage />,
  },

  // wwAdmin
  {
    path: `${rootUrl}/wwadmin`,
    element: <WWAdminDashboard></WWAdminDashboard>,
    errorElement: <ErrorPage />,
  },
{
    path: `${rootUrl}/wwadmin/inventoryquery`,
    element: <WWAdminInventoryQuery></WWAdminInventoryQuery>,
    errorElement: <ErrorPage />,
  },

  {
    path: `${rootUrl}/orderSystem`,
    errorElement: <ErrorPage />,
    element: <OrderSystem>
    </OrderSystem>,
    children: [
      {
        path: `${rootUrl}/orderSystem`,
        errorElement: <ErrorPage />,
        element: <OSHome></OSHome>
      },
      {
        path: `${rootUrl}/orderSystem/product/:id`,
        errorElement: <ErrorPage />,
        element: <ProductDetail></ProductDetail>
      },
      {
        path: `${rootUrl}/orderSystem/cart`,
        errorElement: <ErrorPage />,
        element: <Cart></Cart>
      },
      {
        path: `${rootUrl}/orderSystem/checkout`,
        errorElement: <ErrorPage />,
        element: <Checkout></Checkout>
      },
      {
        path: `${rootUrl}/orderSystem`,
        errorElement: <ErrorPage />,
        element: <OSHome></OSHome>
      },
    ]
  },
  {
    path: `${rootUrl}/inventoryQuery`,
    errorElement: <ErrorPage />,
    element: <InventoryQuery>
    </InventoryQuery>
  },
  {
    path: `${rootUrl}/ordersystem`,
    element: <OrderSystem></OrderSystem>,
    errorElement: <ErrorPage />
  },
  {
    path: `${rootUrl}/app3`,
    element: <App3 />,
    errorElement: <ErrorPage />,
    children:[
      {
        path: `${rootUrl}/app3/pdts`,
        element: <App3Pdts />,
        errorElement: <ErrorPage />,
      },
      {
        path: `${rootUrl}/app3/poses`,
        element: <App3Poses />,
        errorElement: <ErrorPage />,
      },
    ]
  },
  {
    path: `${rootUrl}/app2`,
    element: <App2 />,
    errorElement: <ErrorPage />,
    children:[
      {
        path: `${rootUrl}/app2`,
        errorElement: <ErrorPage />,
        element: <Intro />
      },
      {
        path: `${rootUrl}/app2/search`,
        element: <SearchResult />,
        errorElement: <ErrorPage />
      },
      {
        path: `${rootUrl}/app2/aboutUs`,
        errorElement: <ErrorPage />,
        element: <AboutUs />,
        children:[
          {
            path: `${rootUrl}/app2/aboutUs/profile`,
            element: <div>profile</div>,
          },
          {
            path: `${rootUrl}/app2/aboutUs/howWeWork`,
            element: <div>how we work</div>,
          },        ]
      },
      {
        path: `${rootUrl}/app2/aboutUs`,
        element: <h1>about us</h1>
      },
      {
        path: `${rootUrl}/app2/aboutUs/:id`,
        element: <PdtCatDetail />
      },
      {
        path: `${rootUrl}/app2/pdtCatDetail`,
        element: <div className='content'>
          <div className='row justify-content-md-center'>
            <div className='col-md-11'>
              <strong>product categories</strong>
            </div>
          </div>
        </div>
      },
      {
        path: `${rootUrl}/app2/pdtDetail/:id`,
        element: <PdtCatDetail />
      },
      // {
      //   path: `${rootUrl}/app2/pdtDetail/`,
      //   element: <h1>product detail</h1>
      // },
      // {
      //   path: `${rootUrl}/app2/pdtDetail/:pdtCatid`,
      //   element: <h1>product category detail</h1>
      // },
      {
        path: `${rootUrl}/app2/pdtDetail/:pdtCatid/:pdtId`,
        element: <PdtDetail />
      }

    ]
  },
  // app2 manage
  {
    path: `${rootUrl}/app2/manage`,
    element: <Manage2 />,
    errorElement: <ErrorPage />,
    children:[
      // manage homepage
      {
        path: `${rootUrl}/app2/manage`,
        element: <h1>manage home page</h1>,
        errorElement: <ErrorPage />,
      },
      // test
      {
        path: `${rootUrl}/app2/manage/test`,
        element: <Test></Test>,
        errorElement: <ErrorPage />,
      },
      // processes
      {
        path: `${rootUrl}/app2/manage/processes`,
        element: <div><Outlet /></div>,
        errorElement: <ErrorPage />,
        children:[
          {
            path: `${rootUrl}/app2/manage/processes/salesOrder`,
            element: <SalesOrderProcess />,
            errorElement: <ErrorPage />
          },{
            path: `${rootUrl}/app2/manage/processes/purchaseOrder`,
            element: <h1>purchaseOrder</h1>,
            errorElement: <ErrorPage />
          },{
            path: `${rootUrl}/app2/manage/processes/sampleRequest`,
            element: <h1>sampleRequest</h1>,
            errorElement: <ErrorPage />
          }
        ]
      },
      // BBS
      {
        path: `${rootUrl}/app2/manage/BBS`,
        element: <BBS />,
        errorElement: <ErrorPage />
      },
      // tables
      {
        path: `${rootUrl}/app2/manage/Tbl/:tblName`,
        element: <div className="container">
          <Tbl
            useParams={true}
            showTitle={true}
            showSearch={true}
            showPagination={true}
            showListViewSelector={true}
            showBtnNew={true}
          />
        </div>,
        errorElement: <ErrorPage />
      },
      // inventory
      {
        path: `${rootUrl}/app2/manage/inventory`,
        element: <Inventory />,
        errorElement: <ErrorPage />,
        children:[
          {
            path: `${rootUrl}/app2/manage/inventory/inventoryChk`,
            element: <InventoryChk />,
            errorElement: <ErrorPage />,
          },
          {
            path: `${rootUrl}/app2/manage/inventory/inventoryChk2`,
            element: <InventoryChk2 />,
            errorElement: <ErrorPage />,
          },
          {
            path: `${rootUrl}/app2/manage/inventory/inventoryVerify`,
            element: <InventoryVerify />,
            errorElement: <ErrorPage />,
          },
          {
            path: `${rootUrl}/app2/manage/inventory/ProductChk`,
            element: <ProductChk />,
            errorElement: <ErrorPage />,
          },
          {
            path: `${rootUrl}/app2/manage/inventory/CombinePdts`,
            element: <CombinePdts />,
            errorElement: <ErrorPage />
          },
          {
            path: `${rootUrl}/app2/manage/inventory/inventoryHistory`,
            element: <InventoryHistory />,
            errorElement: <ErrorPage />
          }

        ]
      },
      // database
      {
        path: `${rootUrl}/app2/manage/db`,
        element: <div><Outlet /></div>,
        errorElement: <ErrorPage />,
        children:[
          {
            path: `${rootUrl}/app2/manage/db/tblDesign`,
            element: <TableDesign />,
            errorElement: <ErrorPage />
          },
          {
            path: `${rootUrl}/app2/manage/db/tblLogs`,
            element: <TblLogs></TblLogs>,
            errorElement: <ErrorPage />
          },
          {
            path: `${rootUrl}/app2/manage/db/tools`,
            element: <div
              className="container p-3"
            >
              <div
                className="row"
              >
                <h1>tools</h1>
                <ol>
                  {/* change all inv chgs' warehouse id to toronto warehouse */}
                  <li><a href="#"
                    className="text-decoration-none"
                    onClick={evt=>{
                      let warehouseId;
                      if(warehouseId = parseInt(prompt("please input warehouse id:"))){
                        axios_with_token({
                            method: "post",
                            data: {
                                page: 0,
                                rcdsPerPage: 99999
                            },
                            __action: "gettblrcds",
                            __tbl: "inventoryChangeItems"
                        }).then(res=>{
                          return axios_with_token({
                            method: "post",
                            data: {
                              rcds: res.data.data.rcds.map(rcd=>{
                                rcd.warehouseId = warehouseId;
                                return rcd;
                              })
                            },
                            __tbl: "inventoryChangeItems",
                            __action: "addtblrcds"
                          });
                        }).then(res=>{
                          alert('done!');
                        }).catch(err=>{
                            console.log(err.message);
                        });
                      }

                    }}  
                  >change all inv chg rcds' warehouse ids
                  </a></li>

                  {/* add posQtys to all inv chgs rcds */}
                  {/* (pdtId) posId, skidId, qty, unit, origin */}
                  <li><a href="#"
                    className="text-decoration-none"
                    onClick={evt=>{
                      axios_with_token({
                          method: "post",
                          data: {
                              page: 0,
                              rcdsPerPage: 99999
                          },
                          __action: "gettblrcds",
                          __tbl: "inventoryChangeItems"
                      }).then(res=>{
                        return axios_with_token({
                          method: "post",
                          data: {
                            rcds: res.data.data.rcds.map(rcd=>{
                              rcd.posQtys = JSON.stringify([{
                                posId: rcd.posId,
                                skidId: rcd.skidId,
                                qty: rcd.qty,
                                unit: rcd.unit,
                                origin: rcd.origin
                              }]);
                              return rcd;
                            })
                          },
                          __tbl: "inventoryChangeItems",
                          __action: "addtblrcds"
                        })
                      }).then(res=>{
                        alert('done!');
                      }).catch(err=>{
                          console.log(err.message);
                      });
                    }}  
                  >change all inv chg rcds' qtyPos
                  </a></li>
                </ol>

              </div>

            </div>,
            errorElement: <ErrorPage />
          }
        ]
      },
      // settings
      {
        path: `${rootUrl}/app2/manage/settings`,
        element: <div><Outlet /></div>,
        errorElement: <ErrorPage />,
        children:[
          {
            path: `${rootUrl}/app2/manage/settings/usersSettings`,
            element: <UsersSettings />,
            errorElement: <ErrorPage />
          },

          {
            path: `${rootUrl}/app2/manage/settings/menuSettings`,
            element: <MenuSettings />,
            errorElement: <ErrorPage />
          },

          {
            path: `${rootUrl}/app2/manage/settings/urlsSettings`,
            element: <UrlsSettings />,
            errorElement: <ErrorPage />
          },

          
        ]
      }
    ]

  },
  {
    path: `${rootUrl}/manage`,
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: `${rootUrl}/manage/detail/:itemId`,
        element: <Detail />,
      },
    ]
  },

];
const router = createBrowserRouter(routerDef);
export default routerDef;

const root = ReactDOM.createRoot(document.getElementById('root'));

// function TopApp({children}){
//   const {LoginResult, Login, loggedin, setLoggedin, regSetLoggedin} = useLogin({
//     reg: true
//   });
//   // const [loggedin, setLoggedin] = useState(false);
//   // console.log('children:', children);
//   return <LoginResult>{children}</LoginResult>
// }

root.render(<React.StrictMode>
  {/* <TopApp aaa={<div><RouterProvider router={router} /></div>}> */}
    <RouterProvider router={router} />
  {/* </TopApp> */}
</React.StrictMode>);

// root.render(

//   // [] bare for test
//   // <DataProvider>
//   //   <RouterProvider router={router} />
//   // </DataProvider>

//   <React.StrictMode>
//     <DataProvider>
//     <ErrorBoundary>
//       {/* (bkendUrl==="http://127.0.0.1:5000")&& */}
//       {
//         <span
//           className='util'
//           style={{
//             "position":"fixed",
//             "zIndex":"999999",
//             "backgroundColor":"orange",
//             "right":"0",
//             "bottom":"0"
//           }}
//           onMouseOver={evt=>{
//             evt.target.closest(".util").classList.add("utilMouseOver");
//           }}
//           onMouseLeave={evt=>{
//             evt.target.closest(".util").classList.remove("utilMouseOver");
//           }}
//         >{bkendUrl}
        
//           <SiteEditor />
//         </span>
//       }

//       <RouterProvider router={router} />
//     </ErrorBoundary>
//     </DataProvider>
//   </React.StrictMode>
// );



// Example starter JavaScript for disabling form submissions if there are invalid fields
// (function () {
//   'use strict'

//   // Fetch all the forms we want to apply custom Bootstrap validation styles to
//   var forms = document.querySelectorAll('.needs-validation')

//   // Loop over them and prevent submission
//   Array.prototype.slice.call(forms)
//     .forEach(function (form) {
//       form.addEventListener('submit', function (event) {
//         if (!form.checkValidity()) {
//           event.preventDefault()
//           event.stopPropagation()
//         }

//         form.classList.add('was-validated')
//       }, false)
//     })
// })()


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
